import React from "react"
import TwoColWrapper from "../technical/TwoColWrapper"
import QuoteBlock from "./QuoteBlock"

const TextWithQuoteBlock = ({ block, className }) => {
  return (
    <TwoColWrapper block={block} className="text-with-quote-block">
      <QuoteBlock block={block} className="text-left" />
    </TwoColWrapper>
  )
}

export default TextWithQuoteBlock
